import * as customerTracking from './customerTracking';

const reducers = {
  ...customerTracking,
};

export default reducers;
